export function getQuoteParamsOverrides(): Record<string, string> {
  const overrides: Record<string, string> = {};
  const quoteParamsJson = localStorage.getItem('quoteParams'); // Expected format is a json {[name: string]: value}
  if (quoteParamsJson) {
    const quoteArgs = JSON.parse(quoteParamsJson);
    Object.assign(overrides, quoteArgs);
  }
  const quoteArgsJson = localStorage.getItem('quoteArgs'); // Expected format is a json {[name: string]: value}
  if (quoteArgsJson) {
    const quoteArgs = JSON.parse(quoteArgsJson) as { [name: string]: string };
    for (const [name, value] of Object.entries(quoteArgs)) {
      overrides[`quoteArg-${name}`] = value;
    }
  }

  return overrides;
}
